import React from "react";
import { motion } from "framer-motion";

export function MetricCard({
  label, value, sub, accent = "atlas", icon, index = 0,
}: {
  label: string;
  value: React.ReactNode;
  sub?: React.ReactNode;
  accent?: "atlas" | "gold" | "live" | "neutral";
  icon?: React.ReactNode;
  index?: number;
}) {
  const accentText =
    accent === "gold" ? "text-gold-400" : accent === "live" ? "text-live-400" : accent === "neutral" ? "text-foreground" : "text-atlas-400";
  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4, delay: Math.min(index * 0.05, 0.3) }}
      className="panel p-4"
      data-testid="metric-card"
    >
      <div className="flex items-center justify-between">
        <span className="eyebrow">{label}</span>
        {icon && <span className={accentText}>{icon}</span>}
      </div>
      <div className={`num mt-2 text-2xl font-bold tracking-tight ${accentText}`}>{value}</div>
      {sub && <div className="mt-1 text-xs text-muted-foreground">{sub}</div>}
    </motion.div>
  );
}

export function IntelligenceCard({
  title, action, children, className = "",
}: {
  title: React.ReactNode;
  action?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}) {
  return (
    <section className={`panel p-5 ${className}`} data-testid="intelligence-card">
      <div className="mb-4 flex items-center justify-between gap-2">
        <h3 className="text-base font-semibold text-foreground">{title}</h3>
        {action}
      </div>
      {children}
    </section>
  );
}
